import React from "react";
import { DynamicImport } from "utils/dynamic-import";

const RedesignedRetailerProfilePage = DynamicImport(() => import("./retailer-profile.page"));
const RetailerProfileFormContainer = DynamicImport(() => import("containers/retailer-profile-form"));

export const RetailerProfilePage = (props) =>
    props.isRedesignedPage ? <RedesignedRetailerProfilePage /> : <RetailerProfileFormContainer />;
